export default __webpack_public_path__ + "static/media/wallet.766ad927.svg";